import React from 'react';
import { makeStyles, useMediaQuery } from '@material-ui/core';
import {
    TextField,
    FormControl,
    Checkbox,
    FormControlLabel,
    FormHelperText,
    RadioGroup,
    Radio,
} from '@material-ui/core';
import ButtonBase from '../../Buttons/ButtonBase';

const useStyles = makeStyles({
    form: {
        borderRadius: 20,
        boxShadow: '0 2px 8px 0 rgba(161, 161, 161, 0.5)',
        width: 380,
        overflow: 'hidden',
        backgroundColor: 'white',
        margin: '0 0 0 68px',
        position: 'relative',
        top: 45,
        '@media screen and (max-width: 1080.98px)': {
            width: 'inherit',
        },
        '@media screen and (max-width: 768.98px)': {
            margin: 0,
        }
    },
    headerContainer: {
        backgroundImage: 'linear-gradient(to right, #14b1b2 20%, #22d6d2 85%)',
        padding: '16px 12px 13px'
    },
    title: {
        color: 'white',
        fontSize: 29,
        fontWeight: 900,
        textAlign: 'center',
        '@media screen and (max-width: 499.98px)': {
            fontSize: 26,
        }
    },
    subtitle: {
        color: 'white',
        fontSize: 21,
        fontWeight: 'bold',
        textAlign: 'center',
        '@media screen and (max-width: 499.98px)': {
            fontSize: 18,
        }
    },
    container: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        margin: '22px 0',
        '@media screen and (min-width: 769px) and (max-width: 1080.98px)': {
            padding: '0 120px'
        },
        '@media screen and (max-width: 499.98px)': {
            padding: '0 24px',
        }
    },
    formControl: {
        padding: '0 30px 10px 0',
    },
    radioGroup: {
        justifyContent: 'space-between',
    },
    label: {
        color: '#013957',
    },
    labelActive: {
        color: '#013957',
        fontWeight: 'bold',
    },
    terms: {
        padding: '0',
        '@media screen and (min-width: 769px) and (max-width: 1080.98px)': {
            width: '100%',
        },
    },
    formControlLabelRoot: {
        margin: 0,
        alignItems: 'flex-start',
        width: '95%',
    },
    formControlLabelRootRange: {
        margin: 0,
        alignItems: 'center',
        width: '95%',
    },
    formControlLabel: {
        fontSize: 14,
        color: '#013957',
    },
    linkTerms: {
        color: '#013957',
        fontWeight: 'bold',
    },
    buttonStyle: {
        minWidth: 'inherit',
        width: 324,
        '@media screen and (max-width: 499.98px)': {
            minWidth: 280,
            width: '100%',
        }
    },
    linkStyle: {
        margin: '37px 0 16px',
    },
    TextField: {
        minWidth: 328,
        '@media screen and (min-width: 769px) and (max-width: 1080.98px)': {
            minWidth: '100%',
        },
        '@media screen and (max-width: 499.98px)': {
            minWidth: 'inherit',
            maxWidth: 'inherit'
        }
    },
    checkPadding: {
        padding: '9px 9px 9px 0',
    }
})

const WebinarForm = props => {

    const {
        values,
        handleChange,
        handleBlur,
        errors,
        touched,
        setFieldValue,
        handleSubmit,
        isValid
    } = props;

    const classes = useStyles()
    const isRange = useMediaQuery('@media screen and (min-width: 769px) and (max-width: 1080.98px)')

    const handleChangeMultiple = field => event => {
        event.preventDefault();
        let value = event.target.value;
        setFieldValue(field, value);
    };

    return (
        <form className={classes.form}>
            <div className={classes.headerContainer}>
                <p className={classes.title}>¡Regístrese!</p>
                <p className={classes.subtitle}>¡No pierda esta gran oportunidad!</p>
            </div>
            <div className={classes.container}>
                <FormControl
                    error={touched.role && errors.role ? true : false}
                    className={classes.formControl}
                    component="fieldset"
                >
                    <RadioGroup
                        row
                        aria-label="role"
                        name="role"
                        classes={{root: classes.radioGroup}}
                        value={values.role}
                        onChange={handleChangeMultiple('role')}
                        onBlur={handleBlur}
                    >
                        <FormControlLabel
                            value="abogado"
                            control={<Radio color="secondary"/>}
                            label="Abogado"
                            classes={{
                                root: values.role && values.role === 'lawyer' ?
                                    classes.labelActive :
                                    classes.label
                            }}
                        />
                        <FormControlLabel
                            value="despacho"
                            control={<Radio color="secondary" />}
                            label="Despacho"
                            classes={{
                                root: values.role && values.role === 'despacho' ?
                                    classes.labelActive :
                                    classes.label
                            }}
                        />
                    </RadioGroup>
                    {touched.role && errors.role ? (
                        <FormHelperText
                            color="error"
                            classes={{ root: classes.formHelperText }}
                        >
                            {errors.role}
                        </FormHelperText>
                    ) : (
                        ''
                    )}
                </FormControl>

                <TextField
                    label={values.role == "abogado" ? "Nombre(s)*" : "Nombre(s) del Titular*"}
                    type="text"
                    id="name"
                    variant="outlined"
                    classes={{ root: classes.TextField }}
                    onBlur={handleBlur}
                    onChange={handleChange}
                    value={values.name}
                    helperText={touched.name && errors.name ? errors.name : ''}
                    error={touched.name && errors.name ? true : false}
                />

                <TextField
                    label={values.role == "abogado" ? "Apellido(s)*" : "Apellido(s)* del Titular*"}
                    type="text"
                    id="lastName"
                    variant="outlined"
                    classes={{ root: classes.TextField }}
                    onBlur={handleBlur}
                    onChange={handleChange}
                    value={values.lastName}
                    helperText={touched.lastName && errors.lastName ? errors.lastName : ''}
                    error={touched.lastName && errors.lastName ? true : false}
                />

                <TextField
                    label="Correo electrónico*"
                    type="text"
                    id="email"
                    variant="outlined"
                    classes={{ root: classes.TextField }}
                    onBlur={handleBlur}
                    onChange={handleChange}
                    value={values.email}
                    helperText={touched.email && errors.email ? errors.email : ''}
                    error={touched.email && errors.email ? true : false}
                />

                <TextField
                    label="Número de celular*"
                    type="text"
                    id="phone"
                    variant="outlined"
                    classes={{ root: classes.TextField }}
                    onInput={(e) => {
                        e.target.value = e.target.value.replace(/[^0-9]/g, '');
                    }}
                    inputProps={{ minLength: 8, maxLength: 10 }}
                    onBlur={handleBlur}
                    onChange={handleChange}
                    value={values.phone}
                    helperText={touched.phone && errors.phone ? errors.phone : ''}
                    error={touched.phone && errors.phone ? true : false}
                />

                <div className={classes.terms}>
                    <FormControlLabel
                        classes={{
                            root: isRange ?
                                classes.formControlLabelRootRange :
                                classes.formControlLabelRoot,
                            label: classes.formControlLabel,
                        }}
                        control={
                            <Checkbox
                                name="termsAndConditions"
                                id="termsAndConditions"
                                checked={values.termsAndConditions}
                                onChange={event => {
                                    handleChange(event);
                                    handleBlur(event);
                                }}
                                onBlur={handleBlur}
                                value="checked"
                                color="secondary"
                                label="Gilad Gray"
                                classes={{
                                    root: classes.checkPadding
                                }}
                            />
                        }
                        label={
                            <>
                                <p className={values.termsAndConditions ? classes.colorActiveCheck: classes.colorActiveLabel}>
                                    <span className={classes.labelTermino}>Acepto los</span> <a className={classes.linkTerms} href="/informacion-adicional" target="_blank">términos y
                                    condiciones</a>{isRange ? null : <br />}
                                    y la <a className={classes.linkTerms} href="/informacion-adicional" target="_blank">política de privacidad</a> de Contacta Abogado®.
                                </p>
                                {touched.termsAndConditions && errors.termsAndConditions && (
                                    <FormHelperText error>
                                        {errors.termsAndConditions}
                                    </FormHelperText>
                                )}
                            </>
                        }
                    />
                </div>

                <ButtonBase
                    type="submit"
                    onClick={handleSubmit}
                    variant="secondary"
                    disabled={!isValid}
                    buttonStyle={classes.buttonStyle}
                    linkStyle={classes.linkStyle}
                >
                    Quiero asistir al webinar
                </ButtonBase>
            </div>
        </form>
    )
}

export default WebinarForm;
